import { useCallback, useState } from 'react';
import type { PlaylistItem } from './types.ts';
import { AdminPage } from './components/AdminPage.tsx';
import { JoinPage } from './components/JoinPage.tsx';
import { ReviewPage } from './components/ReviewPage.tsx';

export interface JoinedSession {
  name: string;
  items: PlaylistItem[];
  playlistId: string;
  playlistName: string;
  /** Whether this playlist has a manually saved clip order (else clips are sorted by name). */
  manualOrder: boolean;
  /** Whether the project lets reviewers download its clips. */
  canDownload: boolean;
}

/**
 * Two screens, so routing stays a path match rather than a router dependency:
 *   /s/:sessionId  the review room (join screen first)
 *   /              management: projects, uploads, playlists
 */
export function App(): React.JSX.Element {
  const sessionMatch = /^\/s\/([\w-]+)/.exec(location.pathname);
  const sessionId = sessionMatch?.[1] ?? null;

  const [joined, setJoined] = useState<JoinedSession | null>(null);

  const onJoined = useCallback((session: JoinedSession) => {
    setJoined(session);
  }, []);

  if (!sessionId) return <AdminPage />;

  if (!joined) return <JoinPage sessionId={sessionId} onJoined={onJoined} />;

  return (
    <ReviewPage
      sessionId={sessionId}
      displayName={joined.name}
      initialItems={joined.items}
      playlistId={joined.playlistId}
      playlistName={joined.playlistName}
      manualOrder={joined.manualOrder}
      canDownload={joined.canDownload}
    />
  );
}
